import { Platform } from 'react-native';

/**
 * Returns a CSS clamp() expression for web, or the max value as a number for native.
 * Cast as `any` at the call-site because RN's `fontSize` is typed `number`.
 */
export function fluidFontSize(min: number, vw: number, max: number) {
  return Platform.OS === 'web' ? (`clamp(${min}px, ${vw}vw, ${max}px)` as unknown as number) : max;
}

/** Returns a unitless line-height multiplier string on web, or a px value on native. */
export function fluidLineHeight(multiplier: number, maxPx: number) {
  return Platform.OS === 'web' ? (String(multiplier) as unknown as number) : maxPx;
}
